import type React from 'react';

import type { ErrorHandlerProps } from '#src/app/pages/petitionDetails/pageContext';

export const PetitionDetailsErrorHandler: React.FC<ErrorHandlerProps> = ({ context }) => {
	if (context.error === 'user_info_load_failure') {
		throw new Error(`Failed to retrieve data for PetitionDetails page (error: ${context.error})`, {
			cause: context.cause,
		});
	}

	throw new Error(`Failed to retrieve data for PetitionDetails page (error: ${context.error})`);
};
